import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CloseIcon from '@mui/icons-material/Close';
import { Snackbar } from '@mui/material';
import './MapListToast.scss';

export type MapListToastInfo = {
  placeName: string;
  listName: string;
  action: 'added' | 'removed';
};

type MapListToastProps = MapListToastInfo & {
  open: boolean;
  onClose: () => void;
};

function MapListToast({ open, placeName, listName, action, onClose }: MapListToastProps) {
  const preposition = action === 'added' ? 'to' : 'from';

  return (
    <Snackbar
      open={open}
      autoHideDuration={2500}
      onClose={onClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      sx={{ bottom: { xs: 'max(16px, env(safe-area-inset-bottom))', sm: 24 } }}
    >
      <div className='map-list-toast'>
        <button
          className='map-list-toast__close'
          onClick={onClose}
          type='button'
          aria-label='Dismiss'
        >
          <CloseIcon fontSize='small' />
        </button>
        <CheckCircleIcon className='map-list-toast__icon' />
        <span className='map-list-toast__text'>
          <strong>{placeName}</strong> {action} {preposition} <strong>{listName}</strong>
        </span>
      </div>
    </Snackbar>
  );
}

MapListToast.displayName = 'MapListToast';
export default MapListToast;
